import React from "react";

import { GroupBase } from "react-select";
import AsyncSelect, { AsyncProps } from "react-select/async";

import { CustomComponents, useGetDropdownStyles } from "../Dropdown";

export type Props<
  Option,
  IsMulti extends boolean,
  Group extends GroupBase<Option>
> = AsyncProps<Option, IsMulti, Group> & {
  size?: "small" | "medium";
  error?: boolean;
  dataNoTranslate?: boolean;
};

export default function AsyncDropdown<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(props: Props<Option, IsMulti, Group>) {
  const {
    dataNoTranslate,
    styles: ignoreStyles,
    size = "small",
    error = false,
    ...otherProps
  } = props;

  const styles = useGetDropdownStyles<Option, IsMulti, Group>({ size, error });

  return (
    <AsyncSelect
      components={dataNoTranslate ? CustomComponents : undefined}
      styles={styles}
      {...otherProps}
    />
  );
}
